<script>
  import { format } from 'svelte-i18n';

  import { PLUGIN_PROVIDERS_ARRAY } from '@client/enums';

  export let onProviderSelect = () => {};

  let providers = [...PLUGIN_PROVIDERS_ARRAY];

  const onClick = (pluginProvider) => {
    onProviderSelect(pluginProvider);
  };
</script>

<div class="provider-cards">
  {#each providers as provider}
    <div class="provider-card" role="button" tabindex="0" on:click={() => onClick(provider)}>
      <div class="logo">
        <img
          src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          style="background: url('https://assets.opensense.com/plugins/{provider.value}.svg') no-repeat center center; background-size: contain;"
          alt={$format(provider.label)}
          draggable="false"
        />
      </div>
    </div>
  {/each}
</div>

<style lang="scss">
  .provider-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(auto, 200px));
    gap: 24px;
    justify-content: center;
    padding: 0 var(--padding-xxxlarge);
    width: 100%;

    .provider-card {
      align-items: center;
      border: 1px solid var(--border-color);
      border-radius: var(--border-radius-large);
      cursor: pointer;
      display: flex;
      justify-content: center;
      min-height: 100px;
      min-width: 200px;
      transition: all 0.2s;

      &:hover {
        box-shadow: 0 0 0 4px var(--color-gray-100);
      }

      .logo {
        height: 40px;
        width: 100px;

        img {
          background-size: contain !important;
          display: block;
          height: 40px;
          pointer-events: none;
          touch-action: none;
          user-select: none;
          width: 100px;
        }
      }
    }
  }

  @media only screen and (max-width: 675px) {
    .provider-cards {
      grid-template-columns: 1fr;

      .provider-card {
        flex: 1;
      }
    }
  }
</style>
